import PhoneNumberVerification from './PhoneNumberVerification';

export default PhoneNumberVerification;
